import {
  vBoolean,
  vNonEmptyString,
  vObject,
  vOptional,
  type vOutput,
  vString,
} from '../validation/index.ts'

export interface MissedPickup {
  reason: string
  carrierResponse?: string
  isRescheduled: boolean
  additionalDetails?: string
  isArchived?: boolean
  dateReported: Date
  reportedById?: string
  archivedById?: string
  archivedDate?: Date
}

export const missedPickupSchema = vObject({
  reason: vNonEmptyString(),
  carrierResponse: vOptional(vString()),
  isRescheduled: vBoolean(),
  additionalDetails: vOptional(vString()),
})

export type MissedPickupDTO = vOutput<typeof missedPickupSchema>
